import InventoryTable from "./InventoryTable";
import { inventoryColumns, inventoryData } from "./utils";

export const InventoryTab: React.FC = () => {
  return (
    <div>
      <InventoryTable columns={inventoryColumns} data={inventoryData} />
    </div>
  );
};
